<template>

  <div class="clearfix main_center"  v-loading.fullscreen.lock="loading">

    <div class="right-content clearfix" :style="mainContentViewHeight">

      <el-card class="box-card" style="position:relative;text-align: center;">
        <div slot="header" class="clearfix" style="text-align: left">
          <span>快照</span>
        </div>
        <div class="processStatus">
          <img :src="pendingImg" v-if="activityData.historyid == -1">
          <img :src="processedImg" v-if="activityData.historyid == 0">
          <img :src="ignoreImg" v-if="activityData.historyid == 1">
        </div>
        <div :style="{'min-height':cardMinHeight,'text-align':'center'}">
          <img :src="activityData.imgUrl"  v-if="activityData.imgUrl" @error="imgLoadError"  style="width:100%" alt="" >
        </div>
      </el-card>


      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>预警信息</span>
        </div>
        <el-form   label-width="130px" class="form viewFormWrapper">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="预警类别：" >
                <span >{{ activityData.warnTypeName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预警项：">
                <span >{{ activityData.warnItemName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item label="预警内容描述：" >
                <span >{{ activityData.warnContent }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="发生场地：" >
                <span >{{ activityData.warnPlace }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发生时间：" >
                <span >{{ activityData.warnTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
<!--          <el-row :gutter="15">-->
<!--            <el-col :span="12">-->
<!--              <el-form-item label="备注：" >-->
<!--                <span >{{ activityData.remark }}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--          </el-row>-->
        </el-form>
      </el-card>

      <el-card class="box-card" style="margin-bottom:0px">
        <div slot="header" class="clearfix">
          <span>操作记录</span>
        </div>
        <el-table
                :data="warnOptrecords"
                border
                :row-class-name="rowClassName"
                style="width: 100%">
          <el-table-column
                  prop="xh"
                  label="序号"
                  align="center"
                  width="80">
          </el-table-column>
          <el-table-column
                  prop="optBehavior"
                  label="操作"
                  align="center"
                  width="180">
          </el-table-column>
          <el-table-column
                  prop="optDesc"
                  align="center"
                  label="操作记录">
          </el-table-column>
          <el-table-column
                  prop="optUser"
                  align="center"
                  label="操作人">
          </el-table-column>
          <el-table-column
                  prop="optTime"
                  align="center"
                  label="操作时间">
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div class="left-content">
      <div class="left-navbar">
        <el-button type="primary" plain size="small" :style="{display:(buttonVisible?'block':'none'),'margin-top':0}" @click="showAuditWindow(0,'')">处理</el-button>
        <el-button type="primary" plain size="small"  :style="{display:(buttonVisible?'block':'none')}" @click="showAuditWindow(1,'')">忽略</el-button>
        <el-button @click="back()" size="small">返回</el-button>
      </div>
    </div>

    <el-dialog title="处理意见" :visible.sync="dialogVisible" width="30%">
      <div class="dialogBox">
        <el-input type="textarea" v-model="auditForm.opinion"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handle()"  style="margin-bottom:20px;">确 定</el-button>
                <el-button @click="dialogVisible = false" class="backBtn">返回</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
  import {tabsCloseCurrentHandle} from "@/utils/routeTab";

  export default {
  props: ["mainContentViewHeight"],
  components: {
  },
  data() {
    return {
      id:'',
      loading:false,
      warnOptrecords:[],
      buttonVisible: true,
      cardMinHeight:(document.documentElement.clientHeight - 632) + 'px',
      processedImg:require('@/assets/images/status_processed.png'),
      pendingImg:require('@/assets/images/status_pending.png'),
      ignoreImg:require('@/assets/images/status_ignore.png'),
      dialogVisible:false,
      auditForm:{
        historyId:null,
        opinion:''
      },
      activityData:{
        warnTypeName:'',
        warnItemName:'',
        warnContent:'',
        warnPlace:'',
        imgUrl:"",
        warnTime:'',
        remark:''
      }
    };
  },
  activated() {
    this.id = this.$route.query.id;
    this.activityData.warnPlace = '';
    this.getDataContent()
    this.getListByPid();
  },
  methods: {
    imgLoadError (e) {
      e.target.src=require('@/assets/images/load_error.png')
      e.target.style="width:auto"
    },
    showAuditWindow(historyId,msg){
      this.dialogVisible = true;
      this.auditForm.opinion = msg;
      this.auditForm.historyId = historyId;
    },
    getDataContent() {
      this.activityData.imgUrl = '';
      this.$http({
        url: '/jzWarnRecords/getWarnInfo?id='+this.id,
        method: 'get'
      }).then(({data}) => {
        if (data) {
          this.activityData = {...data.data}
        }
      })
    },
    back(){
      tabsCloseCurrentHandle();
      this.$router.push({
        name:'warn_record_activity_list',
      })
    },
    handle() {
      if (this.auditForm.opinion == '') {
        this.$message({
          message: '请填写处理意见',
          type: 'warning'
        });
        return;
      }
      this.$http({
        url: '/jzWarnRecords/handle?id='+this.id+"&opinion="+ this.auditForm.opinion + "&historyId="+this.auditForm.historyId,
        method: 'get'}).then(({data}) => {
        if (data) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.dialogVisible = false;
          tabsCloseCurrentHandle()
        } else {
          this.$message({
            message: '操作失败',
            type: 'warning'
          });
        }
      })

    },
    getListByPid() {
      this.$http({
        url: '/jzWarn0ptRecords/getListByPid?parentId='+this.id,
        method: 'get'
      }).then(({data}) => {
        if (data) {
          this.warnOptrecords = data.data;
          if (this.warnOptrecords.length > 0) {
            this.buttonVisible = false;
          }
        }
      })
    },
    rowClassName({ row, rowIndex }) {
      row.xh = rowIndex + 1;
    }
  }
};
</script>

<style lang="less" scope>

  .main_center{
    .right-content{
      .processStatus{
        position: absolute;
        right:20px;
        top: 20px;
        img{
          opacity: 0.5;
        }
      }
    }
    .left-content{
      .left-navbar{
        border:none;
      }
    }
  }



</style>
